import { Tabs }           from "@mantine/core";
import { forwardRef }     from "react";
import { useTranslation } from "react-i18next";

import { REEL, shortenNumber } from "_common/utils";
import BackgroundWrapper       from "_components/atoms/backgroundWrapper";
import Icon                    from "_components/atoms/icon";
import InputFieldVideos        from "_components/atoms/inputFieldVideos";
import Typography              from "_components/atoms/typography";
import ItemList                from "_components/organisms/reactionBox/ItemList";
import useStyles               from "_styles/molecules/ImageInfoModal";
import useStylesReaction       from "_styles/organisms/reactionBox";

const ReelsCommentsContainer = forwardRef ( ( props, ref ) => {

	const {
		activeTab,
		commentInput,
		commentCount,
		currentTabParams,
		displayEmoji,
		likesCount,
		onClose,
		focusState,
		handleEmojiSelect,
		fetchMoreLikes,
		fetchMoreComments,
		handleOnCommentChange,
		handleTabChange,
		handleToggleEmoji,
		addCommentToPost,
		textInput,
		toggleFocusState,
		reel
	} = props;

	const { classes: classesReactionBox } = useStylesReaction ( undefined, { name: "commentsAndLikesPopover" } );

	const { classes } = useStyles ( { displayEmoji }, { name: "commentsAndLikesPopover" } );

	const { t } = useTranslation ();

	return (
		<div ref   = { ref }
			className = { classes.root }
		>
			<BackgroundWrapper className = { classes.backgroundWrapper }>

				<div className = { classes.dialogContent }>
					<div style = { { display: "flex", justifyContent: "end", cursor: "pointer" } }>

						<Icon
							className = { classes.closeIcon }
							name      = "crossIcon"
							onClick   = { onClose }
						/>
					</div>

					<Tabs
						classNames     = { { root: classesReactionBox.rootTabs, tab: classesReactionBox.tab, tabsList: classesReactionBox.tabsList } }
						indicatorColor = "secondary"
						onChange       = { handleTabChange }
						radius         = "lg"
						value          = { activeTab }
					>
						<Tabs.List>

							<Tabs.Tab
								value = "first"
							>
								<Typography
									className = { activeTab !== "second" ? classesReactionBox.activeText : classesReactionBox.unActiveText }
									color     = { activeTab === "second" ? "#757575" : "secondary" }
									size      = "lg"
									title     = { t ( "reactionbox_comments" ) + ` (${ shortenNumber ( commentCount ) })` }
									weight    = "500"
								/>

							</Tabs.Tab>

							<Tabs.Tab
								value = "second"
							>
								<Typography
									className = { activeTab !== "first" ? classesReactionBox.activeText : classesReactionBox.unActiveText }
									color     = { activeTab === "first" ? "#757575" : "secondary" }
									size      = "lg"
									title     = { t ( "reactionbox_likes" ) + ` (${ shortenNumber ( likesCount ) })` }
									weight    = "500"
								/>

							</Tabs.Tab>
						</Tabs.List>

						{activeTab === "first" && (
							<>
								<ItemList
									activeTab     = { 0 }
									dataList      = { currentTabParams.data }
									fetchComments = { fetchMoreComments }
									fetchLikes    = { fetchMoreLikes }
									isDepleted    = { currentTabParams.isDepleted }
									isFetching    = { currentTabParams.isFetching }
									pageNo        = { currentTabParams.pageNo }
								/>

								<div className = { classes.inputComment }>
									<InputFieldVideos
										commentInput      = { commentInput }
										displayEmoji      = { displayEmoji }
										focusState        = { focusState }
										from              = { REEL }
										handleEmojiSelect = { handleEmojiSelect }
										handleOnChange    = { handleOnCommentChange }
										handleSendClick   = { addCommentToPost }
										handleToggleEmoji = { handleToggleEmoji }
										showEmojiIcon     = { false }
										textInput         = { textInput }
										toggleFocusState  = { toggleFocusState }
									/>
								</div>
							</>
						)}

						{activeTab === "second" && (
							<ItemList
								activeTab     = { 1 }
								dataList      = { currentTabParams.data }
								fetchComments = { fetchMoreComments }
								fetchLikes    = { fetchMoreLikes }
								isDepleted    = { currentTabParams.isDepleted }
								isFetching    = { currentTabParams.isFetching }
								pageNo        = { currentTabParams.pageNo }
							/>
						)}
					</Tabs>
				</div>
			</BackgroundWrapper>
		</div>
	);
} );

ReelsCommentsContainer.displayName = ReelsCommentsContainer;
export default ReelsCommentsContainer;
